import { Injectable } from '@angular/core';
import { AppEvent } from '../types/event.types';
import { SessionService } from './session.service';
import { FullStory as FS } from '@fullstory/browser';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private readonly sessionService: SessionService) {}

  publishEvent(appEvent: AppEvent): void {
    const newEvent = {
      fullStorySessionId: this.sessionService.retrieveCurrentFullStorySessionId(),
      sessionId: this.sessionService.retrieveCurrentSessionId(),
      timestamp: new Date().getTime(),
      ...appEvent,
    };

    try {
      FS('trackEvent', {
        name: newEvent.eventName || 'unknown',
        properties: newEvent,
      });
    } catch (e) {
      console.error('Error publishing event to FullStory:', e);
    }
  }
}
